import {Company} from "../types/domain/company";

export const MAGDALENA_PARENT_COMPANY_ID = "f72753ea-22c2-428c-b69f-0c95d7fcd6af";

export const isMagdalenaCompany = (company: Company) =>
    company.parentCompaniesIds.includes(MAGDALENA_PARENT_COMPANY_ID) || company.id === MAGDALENA_PARENT_COMPANY_ID;
